export default "__VITE_ASSET__DVrdvudX__"